import React from 'react';
import styles from './triangle.module.scss';
import { RoundTriangleSvg } from 'shared/svg';

interface RoundTriangleProps {
  isRotated: boolean;
}

export const RoundTriangle: React.FC<RoundTriangleProps> = ({ isRotated }) => {
  return (
    <div
      className={`${styles.triangle} ${isRotated ? styles['triangle--rotated'] : ''}`}
    >
      <RoundTriangleSvg />
    </div>
  );
};
